export default [
    // packages ordered by priority
    "HTT",
    "HTTF",
    "PFTT",
    "PFTTF",
    "PFPTT",
    "PFPTTF",
    "PFTTNL",
    "PFPTTNL",
    "PFTT_7",
    "PFTT_8",
];
